import React from 'react';
import { isArray, isString } from 'lodash';
import CheckIcon from 'mdi-react/ClipboardCheckOutlineIcon';
import BlockIcon from 'mdi-react/BlockIcon';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { OrderingBook } from 'entities/Reservations';
import { format } from 'date-fns';
import BookStatus from '../BookStatus';
import styles from './BookingComp.module.scss';
import OrderPositions from '../OrderPositions';

type Props = {
  book: any;
  handleOpen: any;
  isManager: boolean;
  onCreateBook: any;
  setCellDate: any;
  maxReservationCount: number;
};

export const BookingComp = ({ book, handleOpen, isManager, onCreateBook, setCellDate, maxReservationCount }: Props) => (
  <>
    <div>
      <div className="d-flex flex-column">
        {isString(book) ? (
          book
        ) : (
          <OverlayTrigger
            key={1}
            placement="top"
            // eslint-disable-next-line
            overlay={
              // @ts-ignore
              !book[0]?.isBlocked ? (
                <span />
              ) : (
                <Tooltip id="tooltip-1">Бронювання на цей час заблоковано завскладом</Tooltip>
              )
            }
          >
            {/* eslint-disable-next-line no-nested-ternary */}
            {book[0]?.isNotBookable ? (
              <button
                type="button"
                className={classNames(styles.mockBtn, book[0]?.isNotBookable ? styles.blockBtn : '')}
              >
                .
                <input
                  type="button"
                  onClick={() => setCellDate('')}
                  // @ts-ignore
                  className={classNames(styles.mockBtn, book[0]?.isNotBookable ? styles.blockBtn : '')}
                />
              </button>
            ) : book[0]?.isBlocked || book[0]?.isWeekendNotBookable || book[0]?.isTomorrowNotBookable ? (
              <button
                type="button"
                className={classNames(styles.mockBtn, book[0]?.isBlocked ? styles.unbookableBtn : '')}
              >
                .
                <input
                  type="button"
                  onClick={onCreateBook}
                  // @ts-ignore
                  className={classNames(styles.mockBtn, book[0]?.isBlocked ? styles.unbookableBtn : '')}
                />
              </button>
            ) : (
              <>
                {/* {book[0]?.id ? null : ( */}
                {/*  <button type="button" className={styles.addBtn}> */}
                {/*    <span className={styles.text}>Add</span> */}
                {/*  </button> */}
                {/* )} */}
                {isArray(book) && book.length >= maxReservationCount ? (
                  <button type="button" className={styles.addBtnTest} onClick={onCreateBook}>
                    <BlockIcon />
                  </button>
                ) : (
                  // eslint-disable-next-line jsx-a11y/control-has-associated-label
                  <button type="button" className={styles.addBtnTest} onClick={onCreateBook} />
                )}
                <button type="button" className={classNames(styles.mockBtn)}>
                  .
                  <input
                    type="button"
                    onClick={onCreateBook}
                    // @ts-ignore
                    className={classNames(styles.mockBtn)}
                  />
                </button>
              </>
            )}
          </OverlayTrigger>
        )}

        {isArray(book) &&
        book.length &&
        (book[0]?.id ||
          (!('isBlocked' in book[0]) &&
            !('isNotBookable' in book[0]) &&
            !('isTomorrowNotBookable' in book[0]) &&
            !('isWeekendNotBookable' in book[0]))) // @ts-ignore
          ? book.map((b: any, index: number) => (
              <>
                {/* {console.log(book)} */}
                {/* {isArray(book) && book.length < 0 ? ( */}
                {/*  <button type="button" className={styles.addBtn} onClick={onCreateBook}> */}
                {/*    <span className={styles.text}>Add</span> */}
                {/*  </button> */}
                {/* ) : ( */}
                {/*  <button type="button" className={styles.addBtnTest} onClick={onCreateBook}> */}
                {/*    <span className={styles.text}>Add</span> */}
                {/*  </button> */}
                {/* )} */}
                <button
                  type="button"
                  key={index}
                  className={styles.component}
                  onClick={(e: any) => {
                    if (e.detail % 2 === 0) {
                      handleOpen(b);
                    }
                  }}
                >
                  <div className="d-flex flex-row align-items-start text-left font-weight-bold">
                    <div className="mt-1">
                      <BookStatus
                        status={b?.bookingStatus}
                        tripStatus={b?.orders?.map((order: any) => order.tripStatus)}
                      />
                    </div>
                    <span className={styles.companyName}>{b?.orders[0]?.company?.name}</span>
                  </div>
                  <div className="mt-2">
                    {b?.orders?.map((order: OrderingBook) => (
                      <>
                        <p className="d-flex align-items-center mb-0" key={order.orderObject}>
                          Зам. №: {order.orderObject}{' '}
                          {!isManager && b.bookingStatus === 2 && (
                            <div className="ml-3">
                              <OrderPositions
                                currentAmount={order.positionsCount || 0}
                                initialAmount={order.approvedPositionCount || 0}
                              />
                            </div>
                          )}
                          {!isManager && order.precomplentation && order.isCompleted && (
                            <CheckIcon className="ml-1 text-success" size={16} />
                          )}
                          {!isManager && order.precomplentation && !order.isCompleted && (
                            <CheckIcon className="ml-1 text-danger" size={16} />
                          )}
                        </p>
                      </>
                    ))}
                    {b?.originalBookingDate ? (
                      <p className="d-flex text-left text-danger mb-0">
                        Бронь на: {format(new Date(b?.originalBookingDate), 'H:mm')}
                      </p>
                    ) : null}
                  </div>
                </button>
              </>
            ))
          : null}
      </div>
    </div>
  </>
);
